import { BaseLayoutVue } from "./BaseLayoutVue";
import { appConfig } from "../../config"
/**Модель представления авторизации */
export class AuthLayoutVue extends BaseLayoutVue {

  /** Ссылка на google play задается в .env */
  get linkAndroid(): string {
    return appConfig.androidUrl;
  }
  /** Ссылка на магазин apple задается в .env */
  get linkIos(): string {
    return appConfig.iosUrl;
  }
  /** Ввывод кнопки перехода на старую версию, зависит от даты, дата задается в .env */
  get dateOldVersion(): boolean {
    const dateOld = new Date(appConfig.dateOld).valueOf();
    return Date.now() < dateOld;
  }
}
